// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/impressum/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const impressumDE: PageEntry = {
  id: "post.impressum",
  locale: "de",
  slug: "impressum",
  seo: {
    navLabel: "Impressum",
    title: "Impressum | Dietz GmbH",
    description: "Impressum",
  },
  type: "post",
  h1: "Impressum",
  blocks: [
    { kind: "heading", level: 2, text: "Impressum" },
    { kind: "heading", level: 2, text: "Angaben gemäß § 5 TMG" },
    { kind: "paragraph", text: "Dietz GmbH Am Floßgraben 10 96465 Neustadt" },
    { kind: "paragraph", text: "Handelsregister: HRB 7729 Registergericht: Amtsgericht Coburg" },
    { kind: "paragraph", text: "Vertreten durch: Geschäftsführer: Dipl.-Wirtsch.-Ing. Matthias Dietz" },
    { kind: "heading", level: 2, text: "Kontakt" },
    { kind: "paragraph", text: "Telefon: +49 (0) 9568 9442-0 Telefax: +49 (0) 9568 9442-22 E-Mail: info@dietz.eu" },
    { kind: "heading", level: 2, text: "Umsatzsteuer-ID" },
    { kind: "paragraph", text: "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE 132406443" },
    { kind: "heading", level: 2, text: "EU-Streitschlichtung" },
    { kind: "paragraph", text: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/ . Unsere E-Mail-Adresse finden Sie oben im Impressum." },
    { kind: "heading", level: 2, text: "Verbraucher­streit­beilegung/Universal­schlichtungs­stelle" },
    { kind: "paragraph", text: "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen." }
  ],
};
